export default "__VITE_ASSET__BPMNnNqj__"